/* Tanboutique — extra's (19-10-2026): routine, vaak samen gekocht, bijna-uitverkocht bij varianten */
(function () {
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents) {
    var fmt = (window.TB && TB.moneyFormat) || '€{{amount_with_comma_separator}}';
    var v = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }
  function updateCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      $$('[data-tb-cartcount]').forEach(function (el) { el.textContent = c.item_count; el.setAttribute('data-count', c.item_count); });
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: c }));
    }).catch(function () {});
  }
  var tt;
  function toast(items) {
    var t = document.getElementById('tb-toast'); if (!t) return;
    var img = t.querySelector('img'), first = items && items[0];
    if (first && first.image && img) { img.src = first.image + (first.image.indexOf('?') > -1 ? '&' : '?') + 'width=120'; img.hidden = false; } else if (img) img.hidden = true;
    var n = t.querySelector('[data-tb-toast-name]');
    if (n) n.textContent = items.length > 1 ? items.length + ' producten toegevoegd' : (first ? first.product_title : '');
    t.classList.add('is-visible'); clearTimeout(tt);
    tt = setTimeout(function () { t.classList.remove('is-visible'); }, 4200);
  }

  /* ---------- groep met aanvinkbare producten (routine + bundel) ---------- */
  function visible(el) { return !el.closest('[hidden]'); }
  function initPicks(g) {
    if (g.dataset.ready) return; g.dataset.ready = '1';
    var btn = g.querySelector('[data-tb-picks-add]');
    function picked() {
      var seen = {};
      return $$('[data-tb-pick]', g).filter(function (p) {
        var c = p.querySelector('input');
        if (!c || !c.checked || c.disabled || !visible(p) || seen[p.dataset.id]) return false;
        seen[p.dataset.id] = 1; return true;
      });
    }
    function refresh() {
      var list = picked(), sum = 0;
      list.forEach(function (p) { sum += parseInt(p.dataset.price, 10) || 0; });
      var none = list.length === 0;
      $$('[data-tb-picks-total]', g).forEach(function (e) { e.textContent = money(sum); });
      $$('[data-tb-picks-count]', g).forEach(function (e) { e.textContent = list.length; });
      $$('.tb-picks__sum, [data-tb-picks-filled]', g).forEach(function (e) { e.hidden = none; });
      $$('[data-tb-picks-empty]', g).forEach(function (e) { e.hidden = !none; });
      if (btn) {
        btn.disabled = none;
        btn.textContent = none ? (btn.dataset.zero || 'Kies je producten') : list.length === 1 ? btn.dataset.one : (btn.dataset.many || '').replace('[n]', list.length);
      }
    }
    g.addEventListener('change', refresh);
    g.tbRefresh = refresh;
    if (btn) btn.addEventListener('click', function () {
      var list = picked(); if (!list.length) return;
      var label = btn.textContent; btn.disabled = true; btn.textContent = '…';
      fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: list.map(function (p) { return { id: parseInt(p.dataset.id, 10), quantity: 1 }; }) })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { alert(res.j.description || res.j.message || 'Toevoegen mislukt'); return; }
          toast(res.j.items || []); updateCount();
        })
        .catch(function () { alert('Toevoegen mislukt, probeer het opnieuw.'); })
        .finally(function () { btn.disabled = false; btn.textContent = label; refresh(); });
    });
    refresh();
  }

  /* ---------- routine: tabs ochtend / avond / extra ---------- */
  function initRoutine(r) {
    if (r.dataset.ready) return; r.dataset.ready = '1';
    var tabs = $$('.tb-routine__tab', r), steps = $$('.tb-routine__step', r), label = r.querySelector('[data-tb-routine-label]');
    function show(m) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.dataset.moment === m ? 'true' : 'false'); });
      var n = 0;
      steps.forEach(function (s) {
        var on = (' ' + s.dataset.moments + ' ').indexOf(' ' + m + ' ') > -1;
        s.hidden = !on;
        if (on) { n++; var num = s.querySelector('.tb-routine__num'); if (num) num.textContent = n; }
      });
      var t = tabs.filter(function (x) { return x.dataset.moment === m; })[0];
      if (label && t) label.textContent = m === 'wk' ? 'wekelijkse ' : t.textContent.trim().toLowerCase();
      var g = r.querySelector('[data-tb-picks]'); if (g && g.tbRefresh) g.tbRefresh();
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.moment); }); });
    // start op het moment waarin het huidige product zit (productpagina), anders het eerste tabblad
    var start = tabs[0] ? tabs[0].dataset.moment : 'am';
    var cur = r.querySelector('.tb-routine__step.has-current');
    if (cur) { var ms = cur.dataset.moments.split(' '); if (ms.length) start = ms[0]; }
    show(start);

    // productpagina: korte verwijzing onder de koopknop
    if (r.dataset.curStep) {
      var pinfo = document.querySelector('.tb-pinfo'), anchor = pinfo && (pinfo.querySelector('[data-tb-stock]') || pinfo.querySelector('[data-tb-atc]'));
      if (anchor && !pinfo.querySelector('.tb-rhint')) {
        var a = document.createElement('a');
        a.className = 'tb-rhint'; a.href = '#routine';
        a.innerHTML = '<span>Stap in je routine</span><strong></strong><em>Bekijk de routine →</em>';
        a.querySelector('strong').textContent = r.dataset.curStep + (r.dataset.curFreq ? ' · ' + r.dataset.curFreq : '');
        a.addEventListener('click', function (e) { e.preventDefault(); r.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        anchor.parentNode.insertBefore(a, anchor.nextSibling);
      }
    }
  }

  /* ---------- vaak samen gekocht ----------
     Basis = regels per categorie (server-side). Zelf gekozen 'aanvullende producten' (Search & Discovery) gaan voor. */
  function initBundle(b) {
    if (b.dataset.ready) return; b.dataset.ready = '1';
    var max = parseInt(b.dataset.max, 10) || 2, box = b.querySelector('[data-tb-bundle-items]'), g = b.querySelector('[data-tb-picks]');
    var cur = box.querySelector('[data-tb-pick].is-current'), curId = cur ? cur.dataset.product : null;
    initPicks(g);
    fetch(b.dataset.url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      var d = document.createElement('div'); d.innerHTML = html;
      var list = $$('[data-tb-bundle-recs] [data-tb-pick]', d).filter(function (p) { return p.dataset.product !== curId; }).slice(0, max);
      if (!list.length) return;
      $$('[data-tb-rule]', box).forEach(function (x) { x.remove(); });
      list.forEach(function (p) {
        var w = document.createElement('div'); w.className = 'tb-bundle__rule'; w.setAttribute('data-tb-rule', '');
        w.innerHTML = '<span class="tb-bundle__plus" aria-hidden="true">+</span>'; w.appendChild(p); box.appendChild(w);
      });
      b.hidden = false; g.tbRefresh();
    }).catch(function () {});
  }

  /* ---------- productpagina: variantwissel → bijna uitverkocht + bundel-prijs ---------- */
  function initPdpExtra(w) {
    var json = w.querySelector('[data-tb-variants]'); if (!json) return;
    var variants; try { variants = JSON.parse(json.textContent); } catch (e) { return; }
    if (variants.length < 2) return;
    function sync() {
      var idEl = w.querySelector('#tb-pform input[name="id"]'); if (!idEl) return;
      var v = variants.filter(function (x) { return String(x.id) === idEl.value; })[0]; if (!v) return;
      var st = w.querySelector('[data-tb-stock]');
      if (st && v.available && v.qty && v.qty <= (parseInt(st.dataset.lowAt, 10) || 5)) {
        st.className = 'tb-stock tb-stock--low'; st.textContent = (st.dataset.low || '').replace('[x]', v.qty);
      }
      var cur = w.querySelector('.tb-bundle [data-tb-pick].is-current');
      if (cur) {
        cur.dataset.id = v.id; cur.dataset.price = v.price;
        var c = cur.querySelector('input'); if (c) { c.disabled = !v.available; if (!v.available) c.checked = false; }
        var pr = cur.querySelector('[data-tb-pick-price]'); if (pr) pr.textContent = v.available ? money(v.price) : 'Uitverkocht';
        var g = cur.closest('[data-tb-picks]'); if (g && g.tbRefresh) g.tbRefresh();
      }
    }
    w.addEventListener('change', function (e) { if (e.target.closest('.tb-variant')) setTimeout(sync, 30); });
  }

  function init(scope) {
    $$('[data-tb-routine]', scope).forEach(initRoutine);
    $$('[data-tb-routine] [data-tb-picks]', scope).forEach(initPicks);
    $$('[data-tb-bundle]', scope).forEach(initBundle);
    $$('[data-tb-pdp]', scope).forEach(initPdpExtra);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
